export enum OnboardingTriggerUserEnum {
    YOUR_LOCAL_6M = "LOCAL_T6M",
    YOUR_LOCAL_3M = "LOCAL_T3M",
    PROFILE_3M = "PROFILE_T3M",
    INVOICE_DOWNLOAD_1M = "INVOICE_DOWNLOAD_T1M",
    ACESS_PAYMENT_3M = "ACESS_PAYMENT_T3M",
    CONSUMPTION_3M = "CONSUMPTION_T3M",
    SELECTOR_CONSUMPTION_1M = "SELECTOR_CONSUMPTION_T1M"
}
